import { apiClient } from '@isocel/front-common';

import { Store } from './types';

export const fetchStores = async (): Promise<Store[]> => {
    const { data } = await apiClient().get(`/stores`);
    return data.sort((a: Store, b: Store) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
};
